<template>
  <div class="register-container">
    <h2>Enter your personal information to complete registration</h2>
    <el-form ref="postForm" :model="postForm" :rules="postRules" class="demo-ruleForm" autocomplete="on">
      <div class="register-main-container">
        <el-row>
          <el-col :span="24">
            <el-form-item label="Name:" style="margin-bottom: 30px;" prop="name">
              <el-input v-model="postForm.name" style="width:50%;" class="filter-item" placeholder="Name" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Email:" style="margin-bottom: 30px;" prop="email">
              <el-input v-model="postForm.email" style="width:50%;" class="filter-item" placeholder="Email" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Password:" style="margin-bottom: 40px;" prop="password">
              <el-input
                :key="passwordType"
                ref="password"
                v-model="postForm.password"
                style="width:50%;"
                :type="passwordType"
                placeholder="Password"
                autocomplete="on"
                @keyup.native="checkCapslock"
                @blur="capsTooltip = false"
              />
              <span class="show-pwd" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Confrim Password:" style="margin-bottom: 40px;" prop="confirmPassword">
              <el-input
                :key="passwordType"
                ref="confrimpassword"
                v-model="postForm.confirmPassword"
                style="width:50%;"
                :type="passwordType"
                placeholder="Confrim Password"
                autocomplete="on"
                @keyup.native="checkCapslock"
                @blur="capsTooltip = false"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Country:" style="margin-bottom: 20px;" prop="country">
              <el-select v-model="postForm.country">
                <el-option
                  v-for="item in countryOpitons"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="What do you want us to contact you:" style="margin-bottom: 20px;" prop="contact">
              <el-select v-model="postForm.contact">
                <el-option
                  v-for="item in contactOpitons"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Phone(not required):" style="margin-bottom: 30px;" prop="phone">
              <el-input v-model="postForm.phone" style="width:50%;" class="filter-item" placeholder="Phone" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button type="success" @click="onCreateEvent($event)">Submit</el-button>
              <el-button type="default" @click.native.prevent="returnLogin()">Back</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import UserResource from '@/api/user'
const userResource = new UserResource()
export default {
  name: 'Register',
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Name filed is required.'))
      } else {
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Email filed is required.'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        if (this.isEdit) {
          if (value === this.postForm.confirmPassword) {
            callback()
          } else {
            callback(new Error('Confirm password and password do not match'))
          }
        } else {
          callback(new Error('Password filed is required.'))
        }
      } else {
        if (value.length < 6) {
          callback(new Error('The password must be at least 6 characters long'))
        } else if (this.postForm.confirmPassword.length !== 0 &&
                  value !== this.postForm.confirmPassword) {
          callback(new Error('Confirm password and password do not match'))
        } else {
          callback()
        }
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        if (this.isEdit) {
          if (value === this.postForm.password) {
            callback()
          } else {
            callback(new Error('Confirm password and password do not match'))
          }
        } else {
          callback(new Error('Confrim Password filed is required.'))
        }
      } else {
        if (this.postForm.password.length !== 0) {
          if (value === this.postForm.password) {
            callback()
          } else {
            callback(new Error('Confirm password and password do not match'))
          }
        } else {
          callback()
        }
      }
    }
    return {
      postForm: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        country: 999,
        contact: 0,
        phone: ''
      },
      postRules: {
        name: [{ validator: validateName }],
        email: [{ validator: validateEmail }],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      redirect: undefined,
      otherQuery: {},
      countryOpitons: [],
      contactOpitons: [
        { value: 0, label: 'Don\'t contact' },
        { value: 1, label: 'Phone' },
        { value: 2, label: 'Email' }
      ],
      errorCodeMessage: {
        0: { 'type': 'success', 'title': 'Thanks for your registration', 'message': 'We will contact you as soon as possible' },
        2: { 'type': 'warning', 'title': 'Opps', 'message': 'This email already exists.' },
        99: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again.' }
      }

    }
  },
  created() {
    this.countryOption()
  },
  methods: {
    async countryOption() {
      const { data } = await userResource.countryOptions()
      const getCountryOpitons = []
      data.forEach(function(item) {
        getCountryOpitons.push({ value: item.id, label: item.name })
      })
      this.countryOpitons = getCountryOpitons
    },
    checkCapslock({ shiftKey, key } = {}) {
      if (key && key.length === 1) {
        if (shiftKey && (key >= 'a' && key <= 'z') || !shiftKey && (key >= 'A' && key <= 'Z')) {
          this.capsTooltip = true
        } else {
          this.capsTooltip = false
        }
      }
      if (key === 'CapsLock' && this.capsTooltip === true) {
        this.capsTooltip = false
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    onCreateEvent() {
      this.$refs.postForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.sendData()
      })
    },
    async sendData() {
      const { data } = await userResource.register(this.postForm)
      if (data.code === 0) {
        this.resetData()
        this.$router.push({
          path: '/admin/register/thankyou'
        });
      } else {
        this.messageNotify(
          this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    },
    resetData() {
      this.postForm = {
        email: '',
        password: '',
        confirmPassword: '',
        country: 999,
        contact: 0,
        phone: ''
      }
    },
    returnLogin() {
      this.$router.push({
          path: '/admin/login'
        });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";

.register-container {
  margin: 10px;

  .register-main-container {
    padding: 40px 45px 20px 50px;

    .postInfo-container {
      position: relative;
      @include clearfix;
      margin-bottom: 10px;

      .postInfo-container-item {
        float: left;
      }
    }
  }

  .word-counter {
    width: 40px;
    position: absolute;
    right: 10px;
    top: 0px;
  }
}

.article-textarea >>> {
  textarea {
    padding-right: 40px;
    resize: none;
    border: none;
    border-radius: 0px;
    border-bottom: 1px solid #bfcbd9;
  }
}
</style>
